module.exports = __webpack_public_path__ + "images/img_21.png";